module.exports = __webpack_public_path__ + "img/speedCase.e7d26212.png";